import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { axios } from '@/axios';
import { isEmpty, parseFilter } from '@/util';
import { config } from '@/config';
import {
  InputText,
  Label,
  InputTextarea,
  TEOLoader,
  Button,
  InputSelect,
  Multiselect,
} from '@teo/components';
import UploadMainImage from '@/components/UploadMainImage/UploadMainImage';
import { langData } from '@/mocks/landData';
import { useGet } from '@/query/fetchHooks';
import AddCompetenceLP from '@/components/Competencies/AddCompetenceLP';
import { CrossFilled } from '@teo/components/icons';

const EditLearningPathHomepage = ({
  setActiveEdit,
  learningpathId,
  learningpath,
  setLearningpath,
  setImage,
  image,
  isOwner,
  authLang,
  setNewLpCompetencies,
  newLpCompetencies,
  setLpCompetencies,
  lpCompetencies,
  refetchCompetencies,
}: any) => {
  const { t } = useTranslation();
  const [name, setName] = useState(learningpath?.lpName || '');
  const [description, setDescription] = useState(
    learningpath?.lpDescription || ''
  );
  const [selectLang, setSelectLang] = useState<any>('nl');
  const [newLangData, setNewLangData] = useState<any>([]);

  const [addCompetency, setAddCompetency] = useState(false);

  const [loadingImgSpinner, setLoadingImgSpinner] = useState<any>(false);
  useEffect(() => {
    const sortLangData = langData
      ?.map((el) => ({
        ...el,
        name: t(`langs.${el?.value}`),
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    setSelectLang(
      sortLangData?.find((option) => option?.value === learningpath?.lang) ||
        'nl'
    );
    setNewLangData(sortLangData);
  }, [langData]);

  const save = async () => {
    const changes: any = {};
    if (name !== learningpath?.lpName) {
      changes.lpName = name;
      setLearningpath((prev: any) => ({ ...prev, lpName: name }));
    }
    if (description !== learningpath?.lpDescription) {
      changes.lpDescription = description;
      setLearningpath((prev: any) => ({ ...prev, lpDescription: description }));
    }
    const promises = [];
    if (!isEmpty(changes)) {
      promises.push(
        axios.put(`${config.backend}/learningpath/${learningpathId}`, changes)
      );
    }
  };

  const changeImage = (value: any) => {
    setImage(value);
    axios.put(`${config.backend}/learningpath/${learningpathId}`, {
      lpPicture: value,
    });
  };

  const handleActivate = async () => {
    setLearningpath((prev: any) => ({
      ...prev,
      lpPublicationStatus: 'concept',
    }));
    await axios.put(`${config.backend}/learningpath/${learningpathId}`, {
      lpPublicationStatus: 'concept',
    });
  };

  const hendleDeleteComp = async (item: any) => {
    try {
      await axios.delete(`${config.backend}/learningpathcompetence/${item.id}`);
      const listCompetencies = newLpCompetencies?.filter(
        (el: any) => el?.id !== item.id
      );
      setLpCompetencies(listCompetencies);
      setNewLpCompetencies(listCompetencies);
    } catch (error) {
      console.error('Error saving:', error);
    }
  };

  return (
    <div className="relative flex h-full max-h-[calc(100vh_-_150px)] w-full flex-col overflow-auto pt-4">
      {learningpath?.lpPublicationStatus === 'disabled' && (
        <div className="mx-auto w-full max-w-[824px] px-3">
          <div className="my-3 flex flex-col gap-3 rounded-lg bg-error-01 p-4">
            <h3 className="text-base font-semibold text-error-05">
              {t('pages.learning_path.message_title_deactivate')}
            </h3>
            <p className="text-sm text-error-05">
              {t('pages.learning_path.message_deactivate')}
            </p>
            <div>
              <div className="group relative inline-block">
                <Button
                  variant="ghost"
                  onClick={() => handleActivate()}
                  className={`border !bg-error-04 !text-error-01 
                     ${!isOwner && 'opacity-25'}
                      `}
                  disabled={!isOwner}
                >
                  {t('pages.create_edit_course.activate_button')}
                </Button>
                {!isOwner && (
                  <div className="absolute left-0 top-[110%] z-[10] hidden w-[300px] rounded-lg bg-white p-3 text-xs text-grey-08 shadow-[0_0_5px_-1px_rgba(0,0,0,0.3)] group-hover:flex">
                    {t('pages.create_edit_course.message_not_owner')}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {loadingImgSpinner && (
        <div className="mx-auto flex justify-center p-10">
          <TEOLoader loaderSrc="/images/TEOloader.gif" className="w-[100px]" />
        </div>
      )}
      <div className="mx-auto w-full max-w-[824px]">
        <UploadMainImage
          setUploadLogo={changeImage}
          uploadLogo={image}
          courseImg={true}
          learningPathImg={true}
          setLoadingImgSpinner={setLoadingImgSpinner}
          loadingImgSpinner={loadingImgSpinner}
        />
      </div>
      <div className="mx-auto flex w-full max-w-xl flex-col px-3">
        <div className="">
          <h3 className="mb-4 text-xl font-normal">
            {t(`pages.create_publication.template_lang_lp`)}
          </h3>
          <div id="templateLang">
            <InputSelect
              onChange={(lang) => {
                setSelectLang(lang);
                const changes: any = {};
                if (lang?.value !== learningpath?.lang) {
                  changes.lang = lang?.value;
                  setLearningpath((prev: any) => ({
                    ...prev,
                    lang: lang?.value,
                  }));
                  const promises = [];
                  if (!isEmpty(changes)) {
                    promises.push(
                      axios.put(
                        `${config.backend}/learningpath/${learningpathId}`,
                        changes
                      )
                    );
                  }
                }
              }}
              value={
                selectLang
                  ? selectLang
                  : newLangData?.find(
                      (option: any) => option?.value === authLang
                    )
              }
              options={[
                {
                  name: t('pages.create_library.all'),
                  value: 'null',
                  id: 1234567,
                  flag: false,
                },
                ...newLangData,
              ]}
            >
              {(options) => (
                <span>
                  {options?.value != 'null' ? options?.name : options?.name}
                </span>
              )}
            </InputSelect>
          </div>
        </div>
        <div className="mb-2 mt-7 text-sm text-black">
          <Label htmlFor="name">
            <p className="mb-3 text-xl font-normal text-black">
              {t('pages.learning_path.name_lp')}
            </p>
          </Label>
          <InputText
            id="name"
            onChange={(e) => setName(e.currentTarget.value)}
            value={name}
            className="w-full"
            onBlur={save}
          />
        </div>
        <div className="mb-2 mt-6 text-sm text-black">
          <Label htmlFor="description">
            <p className="mb-3 text-xl font-normal text-black">
              {t('pages.learning_path.description_lp')}
            </p>
          </Label>
          <InputTextarea
            id="description"
            limit={300}
            onChange={(e: any) => setDescription(e.target.value)}
            value={description}
            onBlur={save}
          />
        </div>

        <div className="mt-6 mb-4 flex w-full">
          <Button onClick={() => setActiveEdit(true)} className="ml-auto">
            {t('pages.learning_path.btn_start')}
          </Button>
        </div>
      </div>
      {addCompetency && (
        <AddCompetenceLP
          setIsOpenCompetencies={setAddCompetency}
          isOpenCompetencies={addCompetency}
          node={learningpath}
          setNewCompetencies={setNewLpCompetencies}
          newCompetencies={newLpCompetencies}
          competencies={lpCompetencies}
          refetchCompetencies={refetchCompetencies}
          training={false}
        />
      )}
    </div>
  );
};

export default EditLearningPathHomepage;
